import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Box, Typography, Tooltip, MenuItem, Select as MuiSelect, FormControl, OutlinedInput } from '@mui/material'
import { type SelectChangeEvent, type SelectProps as MuiSelectProps } from '@mui/material/Select'
import { forwardRef, type ReactNode, type ForwardedRef } from 'react'
import { AsteriskRed } from '../AsteriskRed/AsteriskRed'
export type SelectProps = MuiSelectProps & {
  label?: string
  required?: boolean
  value?: string | number
  errorMessage?: ReactNode
  tooltipText?: string
  options: { key: string | number, value: string }[]
  placeholder?: string
  renderOption?: ReactNode
}

export const Select = forwardRef(function LabeledSelect(
  { tooltipText, required, label, options, variant, errorMessage, renderOption, fullWidth, ...rest }: SelectProps,
  ref: ForwardedRef<unknown>,
) {
  return (
    <Box width={fullWidth ? '100%' : undefined} alignItems="center" display="flex">
      {label && (
        <Box>
          <Typography fontSize="small">
            {label || <>&nbsp;</>}
            {required && <AsteriskRed />}
            <>&nbsp;</>
            {tooltipText && (
              <Tooltip title={tooltipText}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </Tooltip>
            )}
          </Typography>
        </Box>
      )}
      <FormControl fullWidth variant={variant || 'outlined'}>
        <MuiSelect
          size="small"
          ref={ref}
          input={<OutlinedInput />}
          {...rest}
        >
          {renderOption ?? options.map(option => (
            <MenuItem key={option.key} value={option.key}>
              {option.value}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
      <Typography mt={1} color="red" variant="body2">{errorMessage}</Typography>
    </Box>
  )
})

export type { SelectChangeEvent }
